export default {
    apiKey: "AIzaSyApVP3_SACLS4QZGAT6V3npWvBCLaEz_2U",
    authDomain: "rtvparkstadapp.firebaseapp.com",
    projectId: "rtvparkstadapp",
    storageBucket: "rtvparkstadapp.appspot.com",
    messagingSenderId: "881602617529",
    appId: "1:881602617529:web:4e3cef4efc883218363b68"
}